/** The desktop shell scrolls this panel, not the window, so the router resets it on navigation. */
export const MAIN_PANEL_ID = "main-panel";
